import { getCapitalActivityEventStateBadge } from "features/capital-activity/CapitalActivityUtils";
import { CapitalCallDrawdownForm } from "features/capital-call/drawdown/CapitalCallDrawdownForm";
import { useFundFamilyEventRetrieveSuspense } from "gen/endpoints/fund-family-event/fund-family-event";
import React from "react";
import { useTranslation } from "react-i18next";
import PageBody from "shared/components/layout/PageBody";
import { PageHeader } from "shared/components/layout/PageHeader";
import { useRequiredStringParams } from "shared/hooks/useRequiredStringParams";

export const CapitalCallAllocationPage: React.FC = () => {
  const { fundFamilyId, fundFamilyEventId } = useRequiredStringParams();

  const { data: eventData } = useFundFamilyEventRetrieveSuspense(
    fundFamilyId,
    fundFamilyEventId,
  );

  const { t } = useTranslation(["common", "capitalCall"]);

  return (
    <PageBody>
      <PageHeader
        title={t("capitalCall:allocationOfCall")}
        workflowName={t("capitalCall:capitalCall")}
        badge={getCapitalActivityEventStateBadge(eventData.state, t)}
      />
      <CapitalCallDrawdownForm
        fundFamilyId={fundFamilyId}
        fundFamilyEventId={fundFamilyEventId}
        eventData={eventData}
      />
    </PageBody>
  );
};
